<template>
    <div class="right-contx pull-right box-20190523">
        <div class="top-titx font-16 bgcolor-f6f5fa">您购买的全部课程列表都在这里</div>
        <div class="padding-30 bgcolor-f6f5fa md-19052301x search-my200421">
            <div class="d1 clearfix">
                <input class="pull-left" type="text" id="courseName">
                <p class="pull-left search-btn" id="byCourseName_search">搜索</p>
            </div>
            <div class="d2 color-999">
                <div class="pd clearfix" style="display: flex;">
                    <span class="pull-left">课程类型：</span>
                    <div id="columnId" class="lamu-sp-421 clearfix color-333 pull-left clearfix">

                        <p data-coursetype="2" id="majorClass" class="">等级认定培训视频课程</p>
                    </div>
                </div>
                <div class="pd clearfix" style="display: flex;">
                    <span class="pull-left">专业类型：</span>
                    <div id="majorChoice" class="lamu-sp-421 clearfix color-333 pull-left clearfix">
                        <p v-for="(item,index) in courseWorkTypeList" :key="index" @click="workTypeCut(index)"
                            class="js-search-sortTime majorChoice" :class="item.state === 2?'active':''">
                            {{item.dictWorkTypeName}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!--这里结束-->
        <div class="md-19052301x bgcolor-f6f5fa padding-30">
            <div v-if="!majorFlaf" class="md-hd" style="font-weight: normal;color: #666">共有&nbsp;&nbsp;<span
                    style="color: #fbcb60;margin-right: 6px" id="courseCount">{{courseCount}}</span>门&nbsp;&nbsp;课程
            </div>
            <v-spin class="md-bd" :spinning="loadingFlag" tip="正在读取数据." size="large" style="min-height: 200px;">
                <div v-for="(item,index) in marjorCourseList" :key="index" class="md-19052302-x clearfix md20061001">
                    <a>
                        <div class="left pull-left  no-full-time" style="position: relative;">
                            <div class="course_img" style="position: absolute;">{{item.courseName}}</div>
                            <img src="../../../../static/img/courseBack.jpg" class="left pull-left">
                        </div>
                    </a>
                    <div class="right pull-left"><a href="###">
                            <p class="font-16 color-333 text-overflow tttittt">{{item.courseName}}</p>
                        </a>
                        <div class="color-999 pppp pppp1 p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-luxiangji"></i>课时：<span
                                    class="color-666">{{item.coursePeriod}}</span></p>
                        </div>
                        <div class="color-999 pppp p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-riqi"></i>购买日期：<span
                                    class="color-666">{{item.beginTime}}</span></p>
                            <p class="pull-left"><i class="cusfont cusfont-shijian1"></i>剩余时长：<span
                                    class="color-666">{{item.residueTime}}天</span></p>
                        </div>
                        <div class="p5 clearfix" style="width: 400px;"><span class="color-999"
                                style="width: 100px;">学习进度</span>
                            <v-progress-line :percent="item.courseProgress" status="active" style="width: 100%;">
                            </v-progress-line>
                        </div>
                        <!-- bg-4b94ff -->
                        <p class="p4" v-if="item.residueTime <= 0"><a class="btn-0523x bg-becce1 js-gostudy2">已过期</a>
                        </p>
                        <!-- v-if="item.residueTime >0" -->
                        <p class="p4" v-if="item.residueTime >0"><a @click="toStudy(item)"
                                class="btn-0523x bg-4b94ff js-gostudy2">学习</a>
                        </p>
                    </div>
                </div>
                <div v-if="majorFlaf">暂无课程</div>

                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </v-spin>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue'
    import vuebeauty from 'vue-beauty'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    Vue.use(vuebeauty)
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                total: 0,   //一共多少条
                pagesize: 10,  //一页几条
                currentPage: 1,//当前页
                loadingFlag: false,
                courseWorkTypeList: [],
                majorFlaf: false,
                marjorCourseList: [],
                courseCount: 0
            }
        },
        created() {
            this.$parent.Cut(this.$parent.list[0],0);
            this.loadMajorCourseWorkTypeList(this.currentPage, this.pagesize);
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            toStudy(item) {
                this.$router.push({ path: '/courseDetail/' + item.courseId + "/" + item.classId + "/" + item.workTypeId + "/4" });
            },
            workTypeCut(index) {
                this.loadCourseList(this.courseWorkTypeList[index].dictWorkTypeId);
                this.courseWorkTypeList.forEach(element => {
                    element.state = 1;
                });

                this.courseWorkTypeList[index].state = 2;
            },
            loadCourseList(dictWorkTypeId) {
                let parames = new URLSearchParams();
                parames.append('courseType', 2);
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('classType', 4);
                parames.append('workTypeId', dictWorkTypeId);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectMyCourse', parames).then(resp => {

                    if (resp.data.code === "1") {
                        let ArrayList = [];
                        for (let i = 0; i < resp.data.data.length; i++) {
                            let CourseEnter = resp.data.data[i]
                            let CourseGo = {
                                courseId: 0,
                                courseName: '',//课程名称
                                coursePeriod: 0,
                                beginTime: '', //开始时间
                                endTime: '',//结束时间
                                classId: 0,
                                workTypeId: 0,
                                residueTime: 0,//剩余时间
                                courseProgress: 0//课程学习进度
                            }
                            CourseGo.workTypeId = CourseEnter.workTypeId;
                            CourseGo.courseId = CourseEnter.courseId;
                            CourseGo.coursePeriod = CourseEnter.coursePeriod;
                            CourseGo.classId = CourseEnter.classId;
                            CourseGo.courseName = CourseEnter.courseName;
                            CourseGo.beginTime = this.formatDateYmd(CourseEnter.beginTime);
                            CourseGo.residueTime = CourseEnter.daysRemaining;//剩余时间
                            if (CourseEnter.courseProgress != null) {
                                CourseGo.courseProgress = CourseEnter.courseProgress;
                            } else {
                                CourseGo.courseProgress = 0;
                            }

                            ArrayList.push(CourseGo);
                        }
                        this.marjorCourseList = ArrayList;

                        this.courseCount = this.marjorCourseList.length;

                    } else {
                        this.majorFlaf = true;
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            formatDateYmd(date) {
                if (!date) {
                    return "";
                }
                var date = new Date(date);
                var YY = date.getFullYear() + '/';
                var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                return YY + MM + DD;
            },
            //加载数据
            loadMajorCourseWorkTypeList(page, limit) {
                this.loadingFlag = true;

                let parames = new URLSearchParams();

                parames.append('courseType', 2);
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('classType', 4);

                parames.append('page', page);
                parames.append('limit', limit);


                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectMyCourse', parames).then(resp => {

                    this.total = resp.data.count;
                    if (resp.data.code === '1') {
                        let dictWorkTypeArray1 = [];
                        for (let i = 0; i < resp.data.majorList.length; i++) {
                            let dictWorkTypeVoEnter = resp.data.majorList[i];
                            let dictWorkTypeVoGo = {}
                            if (i === 0) {
                                dictWorkTypeVoGo = {
                                    dictWorkTypeId: '',
                                    dictWorkTypeName: '',
                                    state: 2
                                }
                            } else {
                                dictWorkTypeVoGo = {
                                    dictWorkTypeId: '',
                                    dictWorkTypeName: '',
                                    state: 1
                                }
                            }

                            dictWorkTypeVoGo.dictWorkTypeId = dictWorkTypeVoEnter.workTypeId;
                            dictWorkTypeVoGo.dictWorkTypeName = dictWorkTypeVoEnter.workTypeName;

                            dictWorkTypeArray1.push(dictWorkTypeVoGo);
                        }
                        this.courseWorkTypeList = dictWorkTypeArray1;

                        //根据工种第一条默认查询课程列表数据  工种id  课程类型
                        this.loadCourseList(this.courseWorkTypeList[0].dictWorkTypeId);
                    } else {
                        this.majorFlaf = true;
                    }

                    this.loadingFlag = false;
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            }

        }
    }
</script>

<style scoped>
    .md-19052302-x.md20061001 .right .p4 {
        position: absolute;
        right: 0;
        top: 65px;
        left: auto;
        bottom: auto;
    }

    .btn-0523x {
        width: 165px;
        height: 46px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 6px;
        display: inline-block;
    }

    .bg-4b94ff {
        background: #4b94ff;
    }

    .bg-becce1 {
        background: #becce1;
    }

    a:hover {
        color: #FF9800;
    }

    .md20061001 .btn-0523x {
        width: 88px;
        height: 36px;
        line-height: 36px;
    }

    .bg-becce1.btn-0523x {
        cursor: not-allowed;
    }

    .jindu200610>div span {
        position: absolute;
        top: -18px;
        color: #666;
        width: 50px;
        right: -25px;
        text-align: center;
    }

    .jindu200610>div {
        position: absolute;
        height: 100%;
        border-radius: 6px;
        background: #2b83f3;
    }

    .jindu200610 {
        width: 400px;
        position: relative;
        border-radius: 6px;
        height: 6px;
        background-color: #ddd;
        margin-left: 30px;
    }

    .md20061001 .p5 {
        position: absolute;
        bottom: 20px;
        display: flex;
        align-items: center;
    }

    .md-19052302-x .right .p2 {
        line-height: 30px;
    }

    .md20061001 .pppp .cusfont {
        margin-right: 8px;
    }

    .md20061001 .pppp p {
        width: 180px;
        margin-right: 20px;
    }

    .md20061001 .pppp1 {
        margin-top: 15px;
    }

    .md-19052302-x .right .p2 {
        line-height: 30px;
    }

    .text-overflow {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .tttittt {
        width: 360px;
    }

    .md-19052302-x .right {
        position: relative;
        margin-left: 30px;
        height: 153px;
        width: 575px;
    }

    .md-19052302-x .left {
        position: initial;
        width: 272px;
        height: 153px;
        border-radius: 6px;
        overflow: hidden;
    }

    .md-19052302-x .left>img {
        display: block;
        width: 100%;
    }

    .course_img {
        position: absolute;
        top: 31%;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 19px;
        font-weight: 400;
        letter-spacing: 8px;
        padding: 0 18px;
    }

    .md-19052302-x .left {
        position: initial;
        width: 272px;
        height: 153px;
        border-radius: 6px;
        overflow: hidden;
    }

    .md-19052302-x {
        border-bottom: 1px solid #ddd;
        padding-bottom: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .md-19052301x .md-hd {
        color: #4994ff;
        font-weight: bold;
        line-height: 30px;
        margin-bottom: 15px;
    }

    .bgcolor-f6f5fa {
        background: azure;
    }

    .md-19052301x {
        margin-top: 11px;
        font-size: 14px;
        border-radius: 6px;
    }

    .lamu-sp-421 p {
        float: left;
    }

    .lamu-sp-421 p {
        margin: 0 10px;
        cursor: pointer;
        position: relative;
        user-select: none;
    }

    .lamu-sp-421 p.active {
        color: #3b93f6;
    }

    .search-my200421 .pd {
        line-height: 48px;
    }

    .lamu-sp-421 p {
        float: left;
    }

    .lamu-sp-421 p {
        margin: 0 10px;
        cursor: pointer;
        position: relative;
        user-select: none;
    }

    .search-my200421 .pd {
        line-height: 48px;
    }

    .search-my200421 .d2 {
        padding: 15px 0;
        border: 1px solid #ddd;
        margin-top: 30px;
        border-left: none;
        border-right: none;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }


    .cusfont-search:before {
        content: "\e6e9";
    }

    .search-my200421 .search-btn i {
        font-size: 20px;
        vertical-align: middle;
        margin-right: 6px;
    }

    .search-my200421 .search-btn {
        width: 102px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        background-image: linear-gradient(to right, #63b9fd, #34dbf5);
        cursor: pointer;
    }

    .search-my200421 .d1 input {
        width: 690px;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 4px 0 0 4px;
    }

    .search-my200421 .d1 {
        padding: 0 40px;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .md-19052301x {
        margin-top: 11px;
        font-size: 14px;
        border-radius: 6px;
    }

    .padding-30 {
        padding: 30px;
    }

    .bgcolor-f6f5fa {
        background: azure;
    }

    .md-2018040807-xxw .top-titx {
        line-height: 60px;
        padding: 0 28px;
        border-bottom: 1px solid #ddd;
    }

    .pull-right {
        float: right;
    }

    .md-2018040807-xxw .right-contx {
        width: 940px;
        min-height: 450px;
        padding-bottom: 34px;
        border-radius: 4px;
    }

    .cusfont-more:before {
        content: "\e6ed";
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md2018040401-menux li .iconx {
        font-size: 12px;
    }

    .md2018040401-menux li.active .iconx {
        display: inline-block;
    }

    .md2018040401-menux .md2018040401-lefttextx {
        display: inline-block;
        width: 125px;
    }

    .md-2018040807-xxw .md2018040401-menux .md2018040401-lefttextx {
        width: 95px;
    }

    .md2018040401-menux a {
        display: inline-block;
        width: 100%;
        padding: 0 10px 0 30px;
        line-height: 60px;
        border-bottom: 1px solid #f2f2f2;
    }

    .md2018040401-menux li a {
        border-color: #ddd;
    }

    .md2018040401-menux li.active a {
        background: #4d95ff;
        color: #fff;
    }

    .md2018040401-menux {
        width: 200px;
        border-radius: 6px;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .md-2018040807-xxw .md2018040401-menux {
        background: #f6f5fa;
        width: 168px;
        border-radius: 4px;
    }

    .md-2018040807-xxw {
        margin-top: 16px;
    }

    .color-333 {
        color: #333;
    }

    .md-2018040806-xxw .user-namebox .user-name-xxw {
        font-size: 14px;
        font-weight: bold;
        margin-right: 6px;
    }

    .color-999 {
        color: #999;
    }

    .md-2018040806-xxw .user-namebox {
        margin-top: 36px;
    }

    .md-2018040806-xxw .top-navx-list>a {
        float: left;
        line-height: 32px;
        padding: 0 8px;
        margin-right: 40px;
        color: #fff;
        font-weight: bold;
        border-radius: 16px;
    }

    .md-2018040806-xxw .top-navx-list>a.active {
        color: #4b95ff;
        background: #fff;
    }

    .font-16 {
        font-size: 16px;
    }

    .md-2018040806-xxw .top-navx-list {
        padding-left: 15px;
    }

    img {
        vertical-align: middle;
        border: 0;
        -ms-interpolation-mode: bicubic;
    }

    .md-2018040801-lty img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    .md-2018040801-lty {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 2px solid #4b95ff;
    }

    .md-2018040806-xxw .md-2018040801-lty {
        height: 100px;
        width: 100px;
        border: 4px solid #fff;
        position: absolute;
        top: 0;
        left: 0;
    }

    .md-2018040806-xxw {
        padding-left: 105px;
        padding-top: 13px;
    }

    .md-2018040805-xxw .user-cneter-contianer {
        margin-top: -65px;
        position: relative;
    }

    .top-bg-xxw01 {
        height: 276px;
        box-shadow: 0 0 20px #6478f1;
        background-color: #003262;
        /* margin-top: 50px; */
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .md-2018040805-xxw {
        padding: 1px 30px 20px;
        background: #fff;
        margin-top: -169px;
        margin-bottom: 40px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        min-height: 550px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/mySelfBuyCourse.vue